import { Helmet } from "react-helmet-async";
import { PricingPlans } from "@/components/PricingPlans";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { generatePageTitle, generateCanonicalUrl } from "@/lib/seoConfig";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{generatePageTitle("Pricing Plans")}</title>
        <meta name="description" content="Transparent pricing for iQ Texting's AI-powered SMS platform. All plans include rollover credits, multi-agent routing, and 24/7 AI assistant. Start free trial today." />
        <link rel="canonical" href={generateCanonicalUrl("/pricing")} />
        <meta property="og:title" content={generatePageTitle("Pricing Plans")} />
        <meta property="og:description" content="Transparent pricing for iQ Texting's AI-powered SMS platform. All plans include rollover credits, multi-agent routing, and 24/7 AI assistant." />
        <meta property="og:url" content={generateCanonicalUrl("/pricing")} />
        <meta name="twitter:title" content={generatePageTitle("Pricing Plans")} />
        <meta name="twitter:description" content="Transparent pricing for iQ Texting's AI-powered SMS platform." />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto py-8">
        <Button
          variant="ghost"
          onClick={() => navigate('/dashboard')}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>
        
        <Breadcrumbs items={[{ name: "Pricing", url: "/pricing" }]} />
        
        <div className="mb-6 text-center mt-6">
          <Badge variant="secondary" className="mb-4">
            <Sparkles className="h-3 w-3 mr-1" />
            New Feature
          </Badge>
          <h2 className="text-2xl font-bold mb-2">Rollover Credits Now Available!</h2>
          <p className="text-muted-foreground">
            Unused messages automatically roll over to next month (up to 100% of your plan limit)
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            Rollover credits are valid for 1 full year
          </p>
        </div>
        
        <PricingPlans />
      </div>
    </div>
    </>
  );
};

export default Pricing;
